<template>
    <div class="block w-10/12 py-5 mx-auto">
        <div class="flex justify-between items-center sm:mx-5">
            <h1 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-4xl sm:tracking-tight">{{ $t("Incidents") }}</h1>
            <img v-if="!isGuest" class="h-10 w-auto" :src="logo" alt="Workflow" />
        </div>

        <ul 
            role="list" 
            class="mt-5 divide-y divide-gray-100 overflow-hidden bg-white shadow-sm outline outline-1 outline-gray-900/5 sm:rounded-xl dark:divide-white/5 dark:bg-gray-800/50 dark:shadow-none dark:outline-white/10 dark:sm:-outline-offset-1"
            v-if="incidents.length > 0"
        >
            <li 
                v-for="incident in incidents" :key="incident.id" 
                class="relative flex justify-between gap-x-6 px-4 py-5 hover:bg-gray-50 sm:px-6 dark:hover:bg-white/[0.025]"
            >
                <div class="flex flex-col gap-2">
                    <div class="flex gap-1">
                        <div class="flex-none rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500 dark:bg-gray-400 dark:text-gray-400 dark:ring-gray-400">
                            {{ $t('incident.scope') }} : {{ incident.scope.name }}
                        </div>
                        <div class="flex-none rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500 dark:bg-gray-400 dark:text-gray-400 dark:ring-gray-400">
                            {{ $t('incident.severity') }} : {{ incident.severity.name }}
                        </div>
                        <div class="flex-none rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500 dark:bg-gray-400 dark:text-gray-400 dark:ring-gray-400">
                            {{ $t('incident.state') }} : {{ incident.state.name }}
                        </div>
                    </div>
                    <div class="flex text-md font-semibold text-gray-900 dark:text-white">
                        <a :href="`/incidents/${incident.id}`">
                            <span class="absolute inset-x-0 -top-px bottom-0"></span>
                            {{ incident.subject }}
                        </a>
                    </div>
                    <div class="text-sm text-gray-500 dark:text-gray-400" v-html="incident.body.replace(/<div>&nbsp;<\/div>/gm, '')"></div>
                    <div class="flex items-center gap-x-4">
                        <div class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                            {{ $t('updatedAt') }} :
                            {{ $d(incident.updated_at, 'longNumb') }}
                        </div>

                        <div v-if="incident.started_at" class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                            {{ $t('startedAt') }} :
                            {{ $d(incident.started_at, 'longNumb') }}
                        </div>

                        <div v-if="incident.resolved_at" class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                            {{ $t('resolvedAt') }} :
                            {{ $d(incident.resolved_at, 'longNumb') }}
                        </div>
                    </div>
                </div>
                <div class="flex shrink-0 items-center gap-x-4">
                    <div class="hidden sm:flex sm:flex-col sm:items-end">
                        <ArrowRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                </div>
            </li>
        </ul>
        <div v-else class="mt-5">
            <EmptyState :title="$t('noIncident')" />
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { ArrowRightIcon } from "@heroicons/vue/outline";
import EmptyState from "../components/EmptyState.vue";
import { mapGetters } from "vuex";

const logo = localStorage.getItem("logo");

export default {
    name: "Incidents",
    components: {
        ArrowRightIcon,
        EmptyState,
    },
    data() {
        return {
            incidents: [],
            logo,
        }
    },
    created() {
        this.getIncidents();
    },
    computed: {
        ...mapGetters(["isGuest"]),
    },
    methods: {
        async getIncidents() {
            this.$emit("setLoading", true);
            try {
                const res = await axios.get(`${this.$cookie.getCookie("API")}/api/v1/incidents`);

                const parser = new DOMParser();
                this.incidents = res.data.map(incident => ({
                    ...incident,
                    body: parser.parseFromString(incident.body, 'text/html').body.innerHTML.replaceAll('&nbsp;', '')
                }));
            } catch (error) {
                this.errorHandling(error);
            } finally {
                this.$emit("setLoading", false);
            }
        }
    }
}
</script>
